import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { createPaymentIntent } from "../Redux/Actions/PaymentAction";
import { toast } from "react-toastify";
import PaymentModal from "./PaymentModal";
import CircularProgress from "@mui/material/CircularProgress";

const UnlockContactDetailsModal = ({ id, open, setOpen }) => {
    const [paymentIntentDetails, setPaymentIntentDetails] = useState([]);
    const [paymentModal, setPaymentModal] = useState(false); // Ensure the modal state is tracked correctly
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const Payment = useSelector((state) => state.Payment);

    useEffect(() => {
        Payment.paymentIntent = {}; // Reset paymentIntent on mount
    }, []);

    // Check if paymentIntent is successfully received
    useEffect(() => {
        console.log("Updated Payment Intent:", Payment.paymentIntent);
        if (Payment.paymentIntent && Payment.paymentIntent.clientSecret) {
            setPaymentIntentDetails(Payment.paymentIntent);
            setPaymentModal(true); // Set paymentModal to true when the intent is available
        }
    }, [Payment.paymentIntent]);

    const handleClose = () => {
        setOpen(false); // Close the main modal
    };

    const handlePay = async () => {
        setLoading(true); // Show loading state
        try {
            const res = await dispatch(createPaymentIntent(id));
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoading(false); // Hide loading state after the action
        }
    };

    return (
        <>
            <Dialog
                PaperProps={{
                    sx: (theme) => ({
                        borderRadius: {
                            xs: "10px",
                            sm: "15px",
                            md: "20px",
                        },
                        display: "flex",
                        padding: "20px",
                        flexDirection: "column",
                        height: "auto",
                    }),
                }}
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <div>
                    <div className="flex justify-between items-center mb-4">
                        <span className="text-xl font-bold ">Unlock Contact Details</span>
                        <button onClick={handleClose}>
                            <IoIosCloseCircleOutline size={25} color="#777777" />
                        </button>
                    </div>
                    <div className="border"></div>
                </div>
                <div>
                    <div className="text-[#777777] flex flex-col gap-3 py-5">
                        <p>Dear Member,</p>
                        <p>
                            To continue supporting our mission of connecting Gujarati NRI families and promoting meaningful matrimonial matches,
                            we require a small contribution of <span className="font-bold text-black">$10</span> as a service fee. This helps us
                            maintain and expand our operations, allowing us to provide these essential services to our community.
                        </p>
                        <p>Your contribution will go directly toward the ongoing efforts of our NGO to foster connections and support our work.</p>
                        <p>
                            Please make your payment to access contact details of your match and support the growth of our vibrant community.
                            Thank you for your understanding and generosity!
                        </p>
                        <p>Together, we can make a difference.</p>
                    </div>
                </div>

                <div className="flex justify-center">
                    <button
                        onClick={handlePay}
                        className={`bg-[#E72848] text-white py-2 ${loading ? 'px-8' : 'px-4'} rounded-lg flex items-center justify-center transition-all duration-200 transform hover:scale-[1.02] active:scale-95 shadow-md hover:shadow-lg`}
                        disabled={loading} // Disable the button while payment is being processed
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" /> // Show loader while loading
                        ) : (
                            "Pay Now"
                        )}
                    </button>
                </div>
            </Dialog>

            {/* Only show the PaymentModal if paymentModal state is true */}
            {paymentModal && (
                <PaymentModal
                    id={id}
                    open={paymentModal}
                    setPaymentModal={setPaymentModal}
                    paymentIntentDetails={paymentIntentDetails}
                    setOpen={setOpen}
                />
            )}
        </>
    );
};

export default UnlockContactDetailsModal;
